import { render, staticRenderFns } from "./Ageerement.vue?vue&type=template&id=19288faa&scoped=true"
import script from "./Ageerement.vue?vue&type=script&lang=js"
export * from "./Ageerement.vue?vue&type=script&lang=js"
import style0 from "./Ageerement.vue?vue&type=style&index=0&id=19288faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19288faa",
  null
  
)

export default component.exports